import _toConsumableArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import http from '@/api/http';
export var USER_URL = 'api/v5/sys/user';
export function listUser(data, options) {
  return http.get(USER_URL, data, options).then(function (response) {
    return response.data;
  });
}
export function getUserById(id, data, options) {
  return http.get("".concat(USER_URL, "/").concat(id), data, options).then(function (response) {
    return response.data;
  });
}
export function getUserDetailById(id, data, options) {
  return http.get("".concat(USER_URL, "/").concat(id, "/detail"), data, options).then(function (response) {
    return response.data;
  });
}
export function listUserLoginHistory(id, data, options) {
  return http.get("".concat(USER_URL, "/").concat(id, "/login-history"), data, options).then(function (response) {
    return response.data;
  });
}
export function createUser(data, options) {
  return http.post(USER_URL, data, options);
}
export function updateUserById(id, data, options) {
  return http.put("".concat(USER_URL, "/").concat(id), data, options);
}
export function removeUserById(id, data, options) {
  return http.destroy("".concat(USER_URL, "/").concat(id), data, options);
}
export function listUserTrace(data, options) {
  return http.get("".concat(USER_URL, "/trace"), data, options).then(function (response) {
    return response.data;
  });
}
export function resetUserPassword(id, data, options) {
  return http.post("".concat(USER_URL, "/password/").concat(id), data, options);
}
export function changeCurrentUserPassword(data, options) {
  return http.post("".concat(USER_URL, "/password"), data, options);
}
export function getUserFace(id, data, options) {
  return http.get("".concat(USER_URL, "/face/").concat(id), data, options).then(function (response) {
    return response.data;
  });
}
export function uploadUserFace(id, data, options) {
  return http.post("".concat(USER_URL, "/face/").concat(id), data, options);
}

// mixin
export default {
  data: function data() {
    return {
      user: {
        list: [],
        page: 1,
        size: 10,
        total: 0,
        model: null
      }
    };
  },
  /**
   * 获取用户列表
   */
  methods: {
    // 查询所有数据
    fetchUser: function fetchUser() {
      var _this = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref.data,
        options = _ref.options;
      return listUser(data, options).then(function (responseData) {
        var list = responseData.list,
          total = responseData.total;
        _this.user.list = list;
        _this.user.total = total;
        return responseData;
      });
    },
    // 查询单个数据
    getUser: function getUser() {
      var _this2 = this;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref2.id,
        data = _ref2.data,
        options = _ref2.options;
      return getUserById(id, data, options).then(function (responseData) {
        _this2.user.model = Object.assign({}, data, responseData || {});
        return responseData;
      });
    },
    // 删除数据
    removeUser: function removeUser() {
      var _this3 = this;
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref3.id,
        data = _ref3.data,
        index = _ref3.index,
        options = _ref3.options;
      return removeUserById(id, data, options).then(function (response) {
        var list = _toConsumableArray(_this3.user.list);
        if (index !== undefined) {
          list.splice(index, 1);
        }
        _this3.user.list = list;
        _this3.user.total -= 1;
        return response;
      });
    }
  }
};